var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76172 0.4599C2.85938 0.245056 3.07422 0.108337 3.30859 0.108337H5.67188C5.90625 0.108337 6.12109 0.245056 6.21875 0.4599L6.375 0.733337H8.25C8.58203 0.733337 8.875 1.02631 8.875 1.35834C8.875 1.7099 8.58203 1.98334 8.25 1.98334H0.75C0.398438 1.98334 0.125 1.7099 0.125 1.35834C0.125 1.02631 0.398438 0.733337 0.75 0.733337H2.625L2.76172 0.4599ZM7.82031 9.22943C7.80078 9.73724 7.39062 10.1083 6.88281 10.1083H2.09766C1.58984 10.1083 1.17969 9.73724 1.16016 9.22943L0.730469 2.60834H8.25L7.82031 9.22943Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash-bin.a2e6d71c.svg";
export { ForwardRef as ReactComponent };